<template>
  <div class="page d-flex">
    <MenuComponent />
    <DeveloprsViewComponent />
  </div>
</template>

<script>
import MenuComponent from "@/components/user/layout/MenuComponent.vue";
import DeveloprsViewComponent from "@/components/user/viewComponent/developers/DeveloprsViewComponent.vue";

export default {
  name: "DevelopersView",
  components: {
    MenuComponent: MenuComponent,
    DeveloprsViewComponent: DeveloprsViewComponent,
  },
};
</script>
